import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ErrorState({ message, requestId }) {
    return (_jsxs("div", { role: "alert", style: {
            padding: 16,
            borderRadius: 8,
            background: '#fff5f5',
            border: '1px solid #ffa8a8',
            color: '#c92a2a',
        }, children: [_jsx("p", { style: { margin: 0, fontWeight: 600 }, children: message }), requestId ? (_jsxs("p", { style: { margin: '4px 0 0', fontSize: 12, opacity: 0.7 }, children: ["Request ID: ", requestId] })) : null] }));
}
//# sourceMappingURL=ErrorState.js.map